import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal';
import PropTypes from 'prop-types';

function TooltipModal(props) {
  const [state, setState] = useState({ isShown: false });
  const { triggerContent } = props;
  const showModal = () => {
    setState({ isShown: true });
    window.scrollTo(0, 300);
  };
  const closeModal = () => {
    setState({ isShown: false });
  };

  return (
    <React.Fragment>
      <div>
        <p onClick={showModal}>{triggerContent}</p>
      </div>
      {state.isShown ? (
        ReactDOM.createPortal(
          <Modal id={props.id} closeModal={closeModal} {...props} />,
          document.getElementById('modal-location')
        )
      ) : (
        <React.Fragment />
      )}
    </React.Fragment>
  );
}

TooltipModal.propTypes = {
  triggerContent: PropTypes.any,
  title: PropTypes.any,
  content: PropTypes.any,
  id: PropTypes.string
};

export default TooltipModal;
